<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Ventas</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CSelect
                  label="Sede: "
                  :value.sync="campu_id"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="handleCampusChange"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Desde"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  size="sm"
                  id="init"
                  v-model="filter.init"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Hasta"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  id="end"
                  size="sm"
                  v-model="filter.end"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Cantidad de Ventas"
                  type="text"
                  size="sm"
                  v-model="totalVentas"
                  disabled
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Total de Ventas"
                  type="text"
                  size="sm"
                  v-model="sumaTotalVentas"
                  disabled
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper
          v-if="showSalesTable"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          :items="data_sale_products"
          small
          fixed
          caption="Lista de ventas de productos"
          icon="fas fa-coins"
          @mtdBack="mtdBack"
          :size="'md'"
          :actions="true"
          :myButtons="myButtons"
          @mtd_ticket="mtd_ticket"
          :withActions="'2%'"
        />
        <CTableWrapper
          v-if="showCampusSummary"
          :fields="campus_summary_fields"
          hover
          :striped="true"
          :border="true"
          :items="data_campus_summary"
          small
          fixed
          caption="Resumen de ventas por sede"
          icon="fas fa-building"
          @mtdBack="mtdBack"
          :size="'md'"
          :actions="false"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "client_name", label: "Cliente", _style: "width:10%;" },
  { key: "date_formatted", label: "Fecha", _style: "width:10%;" },
  { key: "method_payment_text", label: "Método de pago", _style: "width:10%;" },
  { key: "detail_sale", label: "Productos", _style: "width:10%;" },
  { key: "subtotal", label: "SubTotal", _style: "width:5%;" },
  { key: "ajustement_amount", label: "Descuento", _style: "width:5%;" },
  { key: "alltotal", label: "Total/Pagado", _style: "width:5%;" },
  { key: "ajustement_motive", label: "Observación", _style: "width:10%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,
  },
  data() {
    return {
      prefix: "sales",
      fields,
      // sale_products,
      totalVentas: 0,
      sumaTotalVentas: 0,
      campu_id: "",
      data: [],
      data_campus: [],
      data_campus_summary: [],
      showCampusSummary: false,
      campus_summary_fields: [
        { key: "campus_name", label: "Sede", _style: "width:50%" },
        { key: "total_sales", label: "Total de Ventas", _style: "width:50%" },
      ],
      // data_sale_quotes: [],
      data_sale_products: [],
      filter: {
        init: null,
        end: null,
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      showSalesTable: true,
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Ticket",
          action: "mtd_ticket",
          icon: "fas fa-file-pdf",
        },
      ],
    };
  },
  watch: {
    campu_id: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.mtd_data();
      }
    },
  },
  computed: {
    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
  },
  created() {
    this.getCampus();
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    handleCampusChange() {
      this.showSalesTable = false;
      this.showCampusSummary = false;
      this.mtd_data();
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/users/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus.push({
            label: "Todos",
            value: "",
          });

          response.data.forEach((element) => {
            this.data_campus.push({
              label: element.name,
              value: element.id,
            });
          });
        }
      });
    },

    mtd_data() {
      if (
        !this.filter.init ||
        !this.filter.end ||
        this.filter.init > this.filter.end
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, selecciona un rango de fechas válido.",
        });
        return;
      }

      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/indexSale",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: this.campu_id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          this.data = response.data;

          if (this.campu_id === "") {
            this.showSalesTable = false;
            this.showCampusSummary = true;

            if (response.campus_summary) {
              this.data_campus_summary = response.campus_summary;
            }

            this.totalVentas = this.data.length;
            this.sumaTotalVentas = this.data
              .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
              .toFixed(2);
          } else {
            this.showSalesTable = true;
            this.showCampusSummary = false;

            this.data_sale_products = this.data.filter(
              (item) => item.type == 0
            );
            this.totalVentas = this.data.length;
            this.sumaTotalVentas = this.data
              .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
              .toFixed(2);

            let index = 1;
            this.data.forEach((item) => {
              item.subtotal = item.total;
              item.alltotal =
                item.state == 1
                  ? (
                      parseFloat(item.total) +
                      parseFloat(item.ajustement_amount)
                    ).toFixed(2)
                  : item.amount;
              item.index = index++;
              item.ajustement_motive = item.ajustement_motive || '';
              item.client_name = item.client?.name || "No especificado";
              item.date_formatted = moment(item.date).format("DD/MM/YYYY");
              item.detail_sale = item.detail.map((det) => {
                if (det.product && det.product != null) {
                  return `[Pro] ${det.product.name} (${det.quantity})`;
                } else if (det.production && det.production != null) {
                  return `[PP] ${det.production.name}`;
                } else {
                  return "Item no encontrado";
                }
              }).join(", ");
              /* item.detail_sale = item.detail
                .map((det) =>
                  det.product
                    ? `${det.product.name} (${det.quantity})`
                    : "Producto no encontrado"
                )
                .join(", "); */

              if (item.method_payment && item.method_payment.name) {
                item.method_payment_text = item.method_payment.name;
              } else {
                item.method_payment_text = "No especificado";
              }

              switch (item?.state) {
                case 0:
                  item.status = "Cancelado";
                  break;
                case 1:
                  item.status = "Pagado";
                  break;
                case 2:
                  item.status = "Pendiente";
                  break;
                default:
                  item.status = "Desconocido";
              }
              if (item.voucher[0].state == 2) {
                item.status += " - ANULADO";
                }
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },

    mtd_ticket(item) {
      if (item?.voucher?.[0]?.id && item?.voucher?.[0]?.detail) {
        const voucher = item.voucher[0].id;
        // const idProduct = item.voucher[0].detail;
        const document_name = item.voucher[0].document_type.name;
        if (document_name == "NOTA DE VENTA") {
          window.open(
            this.$store.getters.get__url +
              "/sales/ticket/" +
              voucher +
              // "/" +
              // idProduct +
              "/" +
              this.$store.getters.get__user_id,
            "_blank"
          );
        } else {
          const sunatData = JSON.parse(item.voucher[0].sunat);
          const ticketUrl = sunatData?.json?.enlace_del_pdf_ticket;
          window.open(ticketUrl, "_blank");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Ticket",
          text: "Está cita todavía no tiene documento",
        });
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-button:hover {
  background-color: #7e4bbf !important;
  border-color: #7e4bbf !important;
}
</style>